function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function ($) {
  $(document).ready(function () {
    var DownloadsPage = /*#__PURE__*/function (_window$HTMLDivElemen) {
      _inherits(DownloadsPage, _window$HTMLDivElemen);

      var _super = _createSuper(DownloadsPage);

      function DownloadsPage() {
        var _this;

        _classCallCheck(this, DownloadsPage);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var self = _this = _super.call.apply(_super, [this].concat(args));

        self.init();
        return _possibleConstructorReturn(_this, self);
      }

      _createClass(DownloadsPage, [{
        key: "init",
        value: function init() {
          this.$ = $(this);
          this.props = this.getInitialProps();
          this.state = this.getInitialState();
          this.resolveElements();
          this.bindFunctions();
          this.bindEvents();
        }
      }, {
        key: "getInitialProps",
        value: function getInitialProps() {}
      }, {
        key: "getInitialState",
        value: function getInitialState() {
          var keywords = $('.downloads_page__search_form input', this).val();
          var activeFilters = $('.downloads_page__filter_link--active');
          var filter = [];
          $.each(activeFilters, function (i, el) {
            var name = $(el).attr('data-type');
            var value = $(el).attr('data-slug');
            var currentFilter = filter[name];

            if (currentFilter == undefined) {
              filter[name] = [value];
            } else {
              var _i = currentFilter.indexOf(value);

              if (_i === -1) {
                filter[name] = [].concat(_toConsumableArray(currentFilter), [value]);
              } else {
                currentFilter.splice(_i, 1);
                filter[name] = currentFilter;
              }
            }
          });
          return {
            filters: filter,
            search: keywords
          };
        }
      }, {
        key: "resolveElements",
        value: function resolveElements() {
          this.$results = $('.downloads_page__main', this);
          this.$filter = $('.downloads_page__filter', this);
        }
      }, {
        key: "bindFunctions",
        value: function bindFunctions() {
          this.onFilterTermClick = this.onFilterTermClick.bind(this);
          this.onFilterChange = this.onFilterChange.bind(this);
          this.onSearch = this.onSearch.bind(this);
          this.filterResources = this.filterResources.bind(this);
          this.setLoadingState = this.setLoadingState.bind(this);
          this.removeLoadingState = this.removeLoadingState.bind(this);
        }
      }, {
        key: "bindEvents",
        value: function bindEvents() {
          this.$.on('click', '.downloads_page__filter_link', this.onFilterTermClick);
          this.$.on('submit', '.downloads_page__search_form', this.onSearch);
        }
      }, {
        key: "onFilterTermClick",
        value: function onFilterTermClick(e) {
          e.preventDefault();
          var $target = e.currentTarget;
          $($target).toggleClass('downloads_page__filter_link--active');
          this.onFilterChange($($target).data('type'), $($target).data('slug'));
          this.filterResources();
        }
      }, {
        key: "onFilterChange",
        value: function onFilterChange(urlParam, value) {
          var currentFilter = this.state.filters[urlParam];

          if (currentFilter == undefined) {
            this.state.filters[urlParam] = [value];
          } else {
            var i = currentFilter.indexOf(value);

            if (i === -1) {
              this.state.filters[urlParam] = [].concat(_toConsumableArray(currentFilter), [value]);
            } else {
              currentFilter.splice(i, 1);
              this.state.filters[urlParam] = currentFilter;
            }
          }
        }
      }, {
        key: "onSearch",
        value: function onSearch(e) {
          e.preventDefault();
          this.state.search = $('input', this).val();
          this.filterResources();
        }
      }, {
        key: "filterResources",
        value: function filterResources() {
          var _this2 = this;

          this.setLoadingState();
          var baseUrl = location.protocol + '//' + location.host + location.pathname;
          var url = new URL(baseUrl);

          if (this.state.search !== '') {
            url.searchParams.append('search', this.state.search);
          }

          var activeFilters = this.state.filters;
          Object.keys(activeFilters).forEach(function (tax) {
            var termsString = activeFilters[tax].join(',');
            url.searchParams.append(tax, termsString);
          });
          window.history.pushState(null, null, url.href);
          url.searchParams.append('contentOnly', 1);
          $.ajax({
            url: url
          }).then(function (response) {
            var $html = $(response);
            var $results = $('.downloads_page__main', $html);

            _this2.$results.html($results.html());

            _this2.removeLoadingState();
          }, function (response) {
            console.error(response);
            $target.removeClass('button--disabled');

            _this2.removeLoadingState();
          });
        }
      }, {
        key: "setLoadingState",
        value: function setLoadingState() {
          this.$.addClass('downloads_page--loading');
        }
      }, {
        key: "removeLoadingState",
        value: function removeLoadingState() {
          this.$.removeClass('downloads_page--loading');
        }
      }]);

      return DownloadsPage;
    }(window.HTMLDivElement);

    window.customElements.define('downloads-page', DownloadsPage, {
      "extends": 'div'
    });
  });
})(jQuery);